import * as React from "react";
import moment = require("moment");

interface State {
	/**
	 * Left offset for the bar in whole SE wrapper.
	 */
	offset: number
}

export default class DayViewCurrentTimeBar extends React.PureComponent<{}, State> {
	timer: number;

	constructor(props: {}) {
		super(props);
		this.state = {offset: this.calculatePositionOnGrid()}
	}

	componentDidMount() {
		this.timer = window.setInterval(() => {
			this.setState({offset: this.calculatePositionOnGrid()})
		}, 1000 * 60);
	}

	componentWillUnmount() {
		if (this.timer) {
			window.clearInterval(this.timer);
		}
	}

	render() {
		return (
			<div className="c-day-view_time-indicator" style={{left: `${this.state.offset}px`}}/>
		)
	}

	/**
	 * Calculate position of bar between 06:00-24:00 based on current time.
	 * @returns {number} left position of the bar
	 */
	calculatePositionOnGrid() {
		const time0 = document.getElementById("time_0");
		const time18 = document.getElementById("time_18");
		if (!time0 || !time18)
			return;
		
		const timelineStartOffset = time0.offsetLeft;
		const timelineEndOffset = time18.offsetLeft;
		const start = moment().set("hours", 6).set("minutes", 0);
		const end = moment().set("hours", 24).set("minutes", 0);
		const now = moment();
		let offset = 0;
		if (now.isBefore(start)) {
			offset = timelineStartOffset;
		}
		else if (now.isAfter(end)) {
			offset = timelineEndOffset;
		}
		else {
			const diff = now.diff(start, "m");
			const wholeDay = end.diff(start, "m");
			const percentage = diff / wholeDay;
			offset = Math.floor(timelineStartOffset + (timelineEndOffset - timelineStartOffset) * percentage);
		}
		return offset;
	}

	refresh() {
		this.setState({offset: this.calculatePositionOnGrid()})
	}
}